import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { APIgetFilesGroupsUsers } from '../../api/Files';

import UsersFilter from '../Filters/Users';

const UploadsFilters = ({ selectedUser, loading, handleChangeUser }) => {
  const loadUsers = useCallback(() => (
    APIgetFilesGroupsUsers({ type: 'upload' })
  ), []);

  return (
    <div className="table-filters">
      <UsersFilter
        selectedUser={selectedUser}
        loading={loading}
        loadUsers={loadUsers}
        handleChangeUser={handleChangeUser}
      />
    </div>
  );
};

UploadsFilters.propTypes = {
  selectedUser: PropTypes.object,
  loading: PropTypes.bool,
  handleChangeUser: PropTypes.func.isRequired,
};

UploadsFilters.defaultProps = {
  selectedUser: null,
  loading: false,
};

export default UploadsFilters;
